// To avoid an error with "&sect" on links, we use "anchor"
export const ACCORDION_SECTION_PARAM_NAME = 'anchor'

export const DEFAULT_AVATAR_IMG = '/img/hozana_img_avatar_default.png'

export enum GENDER {
  M = 'm',
  F = 'f',
}

export const getMeQueryKey = 'getMe'
